import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  Grid,
  Typography 
} from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DatePicker from './DatePick';
import { updateInvoice } from '../actions/invoiceActions';

const InvoicesPayment = ({ invoices }) => {
  const dispatch = useDispatch();
  const [totalDueAmount, setTotalDueAmount] = useState(0);
  const [receiveAmount, setReceiveAmount] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [method, setMethod] = useState(null);

  const paymentMethods = [
    { title: 'Bank Transfer'},
    { title: 'Cash'},
    { title: 'Credit Card'},
    { title: 'PayPal'},
    { title: 'Others'},
  ];

  // Calculate total due amount
  useEffect(() => {
    const totalDue = invoices.reduce((total, invoice) => {
      return total + (Number(invoice.total) - Number(invoice.totalAmountReceived || 0));
    }, 0);
    setTotalDueAmount(totalDue);
  }, [invoices]);

  const handleWriteOff = () => {
    // Sort invoices by oldest first (FIFO approach)
    const sortedInvoices = [...invoices].sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
    
    let remainingAmount = Number(receiveAmount);
    const updatedInvoices = sortedInvoices.map(invoice => {
      const remainingBalance = Number(invoice.total) - Number(invoice.totalAmountReceived || 0);
      
      if (remainingAmount > 0 && remainingBalance > 0) {
        const amountToApply = Math.min(remainingAmount, remainingBalance);
        
        const newTotalAmountReceived = Number(invoice.totalAmountReceived || 0) + amountToApply;
        const newStatus = newTotalAmountReceived >= invoice.total ? 'Paid' : 'Partial';
        
        const newPaymentRecord = {
          amountPaid: amountToApply,
          datePaid: selectedDate,
          paymentMethod: method?.title || 'Not Specified',
          note: 'Bulk Payment Writeoff'
        };
        
        remainingAmount -= amountToApply;
        
        return {
          ...invoice,
          status: newStatus,
          totalAmountReceived: newTotalAmountReceived,
          paymentRecords: [
            ...(invoice.paymentRecords || []),
            newPaymentRecord
          ]
        };
      }
      
      return invoice;
    });
    
    // Dispatch updates for each invoice
    updatedInvoices.forEach(invoice => {
      if (invoice.totalAmountReceived !== invoice.originalTotalAmountReceived) {
        dispatch(updateInvoice(invoice.id, invoice));
      }
    });
    
  };

  // const handleClose = () => {
  //   setOpen(false);
  // };

  return (
   <>
        <Typography variant="h6" gutterBottom>
          Total Due Amount: ${totalDueAmount.toFixed(2)}
        </Typography>
        
        {/* <DatePicker 
          selectedDate={selectedDate} 
          setSelectedDate={setSelectedDate}
        />
        
        <TextField 
          type="number" 
          label="Receive Amount" 
          fullWidth 
          variant="outlined" 
          value={receiveAmount}
          onChange={(e) => setReceiveAmount(e.target.value)}
          style={{margin: '10px 0'}}
        />
        
        <Grid item fullWidth>
          <Autocomplete
            options={paymentMethods}
            getOptionLabel={(option) => option.title || ''}
            style={{ width: '100%' }}
            renderInput={(params) => <TextField {...params} label="Payment Method" variant="outlined" />}
            value={method}
            onChange={(event, value) => setMethod(value)}
          />
        </Grid> */}
     
      
        {/* <Button onClick={handleClose}>Cancel</Button> */}
        <Button onClick={handleWriteOff} color="primary" variant="contained">
          Apply Writeoff
        </Button>
      
    
    </>
  );
};

export default InvoicesPayment;